'use strict';
import {createActions} from 'client/framework';

const normalActions = ['RESET_STORE', 'CHECKBOX_GROUP_SELECTION', 'CHECKBOX_GROUP_DESELECTION'];

export default createActions(null, normalActions);
